//FB 4487 DK - Removed multiple unused imports below
import React, { useContext, useState } from "react";
import Provider from "../components/Provider";
import {
  Grid,
  makeStyles,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
  Button,
  Avatar,
  CardContent,
  Card,
  CardMedia,
  Paper,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { Context, ErrorLog } from "../store";     //FB 4487 DK - Importing ErrorLog class from store
import NavigateBeforeIcon from "@material-ui/icons/ArrowBack";
import NavigateNextIcon from "@material-ui/icons/ArrowForward";
import DateScheduleRow from "./DateScheduleRow";
import { useHistory } from "react-router-dom";
import useStyle from "../css/styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import globalsettings from "../../../config";
//FB 4774 DK - Added reference for formatphone method
//FB-6264
import { formatphone, InsertPELogs, NotifyErrorOutage, GetAdminSettingValue } from "../api";      //FB 4487 DK - Importing the logError method used for error logging , FB 4960, FB 7418

// update log
// FB 4371 DK    03/29/2021    Added page for the slots page in "By Date" workflow
// FB 4409 DK    04/27/2021    Implementation of loading spinner on slots page
// FB 4409 DK    04/30/2021    Added message to show when all available slots are booked
// FB 4487 DK    06/07/2021    Implemented error logging on api call failures
// FB 4574 DK    07/15/2021    Added styling for calender icon
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 4769 MS    11/02/2021    Added Job Title for Provider
// FB 4774 DK    11/16/2021    Modified messages
// FB 4867 DK    01/20/2022    Phone numbe made clickable
// FB 4960 BR    07/03/2022    Logging all actions on PE
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 7418 GS    09/21/2023    Added admin setting to change the message on PE when slots are not available
// FB 7413 GA    09/25/2023    Orady - Update the map link to the correct one
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 7908 SK    01/08/2024    PE Online Appointment Bookings Facility Missing Address 2
// FB 8142 SK    01/23/2024    Sophie - time slots are different when you go with by date vs. by provider flow
// FB 8680 DK    05/21/2024    Practice phone related changes
// FB 9597 DK    10/24/2024    Schedules not loading on PE 
// FB 9742 SK    12/12/2024    No appointments showing up on PE
// FB 9973 DK    01/28/2025    Failed to fetch: GET https://drsamemr.com/api/Provider/GetSlotsByDate


export type Schedule = {
  ScheduleDate: string;
  Slots: string[];
};

export type SchedulesTest = {
  Facility_N: number;
  NextAvailability: string;
  SlotsDate: SlotsDate[];
};

export type SchedulesByDate = {
  Employee_N: number;
  Employee_First_Name: string;
  Employee_Last_Name: string;
  Employee_Image: string;
  NextAvailability: string;
  isInsuranceAccepted: boolean;
  FacilityByDate: FacilityByDate[];
  Employee_Bio: string;
  availableSlotsCount: number;    //FB 4409 DK - Added variable for available slots count
  Duration: number; //FB 4638 added duration field
  Employee_Job_Title: string; //FB 4769
};

export type FacilityByDate = {
  Facility_n: number;
  Facility_Name: string;
  Facility_Address: string;
  Facility_Address2: string;//FB 7908
  Facility_City: string;
  Facility_State: string;
  Facility_Zip: string;
  Slots: string[];
  SchedulinPhone: string;
  GOOGLE_MAPS_LINK: string; //FB 7413
  ApptTypeSlots: string[]; //FB 7801
};

export type SlotsDate = {
  ScheduleDate: string;
  Slots: string[];
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#18a2b8",
    },
    action: {
      selected: "#8BD0DB",
      hover: "#5DBDCD",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  container: {
    //width: "90%",
    margin: "0 auto",
    border: "1px solid rgb(0 0 0 / 25%)",
    backgroundColor: "#fff",
  },
  filter: {
    justifyContent: "flex-start",
    minHeight: "400px",
    minWidth: "10%",
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
  },
  centered: {
    alignSelf: "center",
  },
  content: {
    flex: "1 0 auto",
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginLeft: "10px",
  },
  topBarItem: {
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  margin: {
    margin: theme.spacing(1),
  },
  topBarItem_Day: {
    color: "#A8ABAE",
    textTransform: "uppercase",
    fontWeight: 500,
    letterSpacing: ".1em",
    whiteSpace: "normal",
    fontSize: "10px",
  },
  navigateBackContainer: {
    height: "9vh",
    alignItems: "center",
    justifyContent: "center",
  },
  mainFilter: {
    minHeight: "9vh",
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
  },
  mainFilter_Location_Caption: {
    color: "#A8ABAE",
    fontWeight: "bold",
  },
  slotsContainer: {
    //width: "90%",
    margin: "0 auto",
    //border: "1px solid rgb(0 0 0 / 25%)",
    backgroundColor: "#fff",
  },
  providerRowContainer: {
    overflowY: "auto",
    minHeight: "40vh",
    maxHeight: "55vh",
  },
  borderlessCard: {
    border: "none",
    boxShadow: "none",
  },
  datepickerroot: {
    "& .MuiIconButton-root": {
      color: "#18a2b8",
    },
    // FB 4574 DK - Added styling for increasing the icon size
    "& .MuiSvgIcon-root": {
      fontSize: "2rem"
    }
  },
}));

interface singleDay {
  dateLabel: string;
  hiddenDateValue: string;
}

export type Provider = {
  //name: string;
  //id: number;
  //facility: Facility;
  //schedules: Schedule[];
  schedulesByDate: SchedulesByDate[];
};

export type Facility = {
  id: number;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: string;
};

//FB 4371 DK    Added to get available slots for selected date
export async function GetAvailableSlotsByDate(
  startDate: string,
  location: number,
  provider: number,
  apptType: any,
  insurance_id: number,//FB 7801
  appointment_type_n: number //FB 7801
): Promise<SchedulesByDate[]> {
  let url;
  //FB-6264
  if (apptType === "telederm" && provider === 0) {
    url =
      globalsettings.emrAPI +
      `api/Provider/GetSlotsByDate/-1/${startDate}/1/${insurance_id}/${appointment_type_n}`;//FB 7801
  } else if (apptType === "telederm" && provider > 0) {
    url =
      globalsettings.emrAPI +
      `api/Provider/GetFacilitySlotsForProviderBydate/${provider}/-1/${startDate}/1/${insurance_id}/${appointment_type_n}`;//FB 7801
  } else if (provider === 0) {
    url =
      globalsettings.emrAPI +
      `api/Provider/GetSlotsByDate/${location}/${startDate}/1/${insurance_id}/${appointment_type_n}`;//FB 7801
  } else {
    url =
      globalsettings.emrAPI +
      `api/Provider/GetFacilitySlotsForProviderBydate/${provider}/${location}/${startDate}/1/${insurance_id}/${appointment_type_n}`;//FB 7801
  }
  const response = await fetch(url);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    if (apptType === "inoffice" && provider === 0) {
      data = data.sort(function (x: any, y: any) {
        // true values first
        return x.isInsuranceAccepted === y.isInsuranceAccepted ? 0 : x ? -1 : 1;
      });
    }
    return data as SchedulesByDate[];
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export type ProviderDetails = {
  //Id: number;
  EMPLOYEE_FIRST_NAME: string;
  EMPLOYEE_LAST_NAME: string;
};

export default function Slots_bydate() {
  const classes = useStyles();
  const [indexNumber, setIndexNumber] = React.useState<number>(0);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [providerSchedules, setProviderSchedules] = React.useState<Provider>();
  const [todayDate, setToday] = React.useState<boolean>(false);
  let tempdays: singleDay[] = [];
  const [windowDimensions, setWindowDimensions] = React.useState(
    getWindowDimensions()
  );
  const [limited, setLimit] = React.useState<number>(7);
  const { state, dispatch } = useContext(Context);
  const [weekDay, setWeekDay] = React.useState<number>(0);
  //FB 7418 Begin
  const [textMessage, setTextMessage] = useState("");
  const [textValue, setTextValue] = useState(false);
  //FB 7418 End
  var week = new Array(
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  );
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [outofSlots, setOutofSlots] = useState(false);

  const styles = useStyle();
  //FB 7418 Begin
  const [defaultPhone, setDefaultPhone] = useState(""); //FB 8680

  async function GetSlotsMessage() {
    var data = await GetAdminSettingValue("PE_Slot_Unavailable_Message");
    if (data != "") {
      setTextMessage(data);
      setTextValue(true);
    }
    //FB 8680
    var practicePhone = await GetAdminSettingValue("Default_Sch_Appt_Number");
    if (practicePhone != null) {
      setDefaultPhone(practicePhone);
    }
  }
  //FB 7418 End

  function handleResize() {
    //alert("handleResize");
    setWindowDimensions(getWindowDimensions());
    //alert("Out " + window.innerWidth);
    //if(width < 450){
    //alert(window.innerWidth);
    //constructDates(0);
    //today();
    //}
  }


  const handleDateChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setSelectedDate(date);
      state.appointmentdetails.date = date;
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Changed the date to " + date.toDateString() + " in by date flow");
      //FB 4960 End
    }
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    GetSlotsMessage(); //FB 7418
    //constructDates(0);
    //today();
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  React.useEffect(() => {
    //if (indexNumber === 0) {
    setIndexNumber(0);
    setLoading(true);
    let temp: Provider = {
      schedulesByDate: [],
    };
    //FB 9597
    let session_ApptN = sessionStorage.getItem("AppointmentType_N");//FB 7801
    let appt_type_n = session_ApptN != null && session_ApptN != 'undefined' ? Number(session_ApptN) : 0;
    //FB 9973
    //let custom_appt_type = sessionStorage.getItem("Enable PE Custom Appointments");//FB 8142
    setTimeout(() => {
      (async () => {
        let currentDate = state.appointmentdetails.date;
        let days = currentDate.getDate();
        let value = new Date(currentDate.setDate(days));
        let splittedDate = value.toLocaleDateString().split("/");
        setWeekDay(currentDate.getDay());
        //state.appointmentdetails.date = new Date(state.appointmentdetails.date.getTime() + offset*60*1000)
        temp.schedulesByDate = await GetAvailableSlotsByDate(
          `${splittedDate[0]}-${splittedDate[1]}-${splittedDate[2]}`,
          state.appointmentdetails.location.id,
          state.appointmentdetails.provider.id,
          state.appointmentdetails.appointmenttype,
          state.appointmentdetails.insurance.id,//FB 7801
          Number(appt_type_n) //FB 7801
        );
        setLoading(false);
        //FB 8142 - Modified Approach - Removed Old Code- Begin
        //FB 9742 Removed unused part of code
        if (temp.schedulesByDate.length > 0 && temp.schedulesByDate[0].FacilityByDate[0].Facility_n != 0) {
          setOutofSlots(false);
          setProviderSchedules(temp);
        }
        //FB 7801 - End
        //FB 8142 - End
        else {
          setOutofSlots(true);
          setProviderSchedules(temp);    //FB 4774
        }
      })();
    }, 1000);
    //}
  }, [selectedDate]);

  const history = useHistory();

  const handleGoBack = () => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Slots page by date flow");
    //FB 4960 End
    history.goBack();
  };

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <React.Fragment>
      {outofSlots ? (
        <section
          ref={scrollTo}
          style={{
            margin: "20px 20px 20px",
          }}
        >
          <Grid container direction="row" spacing={3}>
            <Grid item xs={12}>
              <Card className={classes.borderlessCard}>
                <CardContent>
                  <Typography variant="h6">
                    <b>
                      {state.appointmentdetails.appointmenttype === "inoffice"
                        ? "In-office Appointment"
                        : state.appointmentdetails.appointmenttype ===
                          "telederm"
                          ? globalsettings.digitalApptType + " Appointment"
                          : ""}
                    </b>
                  </Typography>
                  <Typography variant="h6">{week[weekDay]}</Typography>
                  <Typography variant="subtitle1">
                    {state.appointmentdetails.date
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })
                      .replace(/ /g, " ")}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    id="dateByDate"
                    className={`${classes.datepickerroot} ${classes.topBarItem}`}
                    fullWidth
                    inputVariant="standard"
                    orientation="portrait"
                    value={selectedDate}
                    label="Pick different date"
                    onChange={(date) => handleDateChange(date)}
                    format="MM/dd/yyyy"
                    minDate={new Date()}
                    initialFocusedDate={null}
                    minDateMessage="Date should not be in past"
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ display: "flex" }}
            direction="row"
            alignContent="center"
            justify="center"
          >
            {loading ? (
              <Grid item xs={12} style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                  style={{ display: "flex", minHeight: "40vh" }}
                >
                  <CircularProgress />
                </Grid>
              </Grid>
            ) : (
              <div>
                <Grid
                  container
                  spacing={3}
                  direction="row"
                  style={{ display: "flex", minHeight: "40vh" }}
                  alignItems="center"
                  justify="center"
                >
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex" }}
                    justify="center"
                    alignItems="center"
                  >
                    <Paper
                      style={{
                        backgroundColor: "#EDEEEE",
                        borderRadius: "16px",
                        padding: "10px",
                        fontSize: "smaller",
                      }}
                    >
                      <Typography>
                        {/* FB 4774 DK - Modified message */}
                        {/* FB 4867 */}
                        There are no online appointments available for this date. Please call {formatphone(state.appointmentdetails.location.phone)} to book an appointment.
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </div>
            )}
          </Grid>
          <Grid
            container
            spacing={2}
            className={styles.flexend_Grid}
            style={{ marginTop: 10, display: "flex" }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className={styles.flexend_Grid}
              style={{ marginTop: 10 }}
            >
              <Button
                id="goBackByDate"
                onClick={handleGoBack}
                variant="contained"
                className={styles.navigationButton}
              >
                Go Back
              </Button>
            </Grid>
          </Grid>
        </section>
      ) : (
        <section
          ref={scrollTo}
          style={{
            margin: "20px 20px 20px",
          }}
        >
          <Grid container direction="row" spacing={3}>
            <Grid item xs={12}>
              <Card className={classes.borderlessCard}>
                <CardContent>
                  <Typography variant="h6">
                    <b>
                      {state.appointmentdetails.appointmenttype === "inoffice"
                        ? "In-office Appointment"
                        : state.appointmentdetails.appointmenttype ===
                          "telederm"
                          ? globalsettings.digitalApptType + " Appointment"
                          : ""}
                    </b>
                  </Typography>
                  <Typography variant="h6">{week[weekDay]}</Typography>
                  <Typography variant="subtitle1">
                    {state.appointmentdetails.date
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      })
                      .replace(/ /g, " ")}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ display: window.innerWidth <= 768 ? "flex" : "none" }}
          >
            <Grid item xs={window.innerWidth === 768 ? 6 : 12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    className={`${classes.datepickerroot} ${classes.topBarItem}`}
                    fullWidth
                    inputVariant="standard"
                    orientation="portrait"
                    value={selectedDate}
                    label="Pick different date"
                    onChange={(date) => handleDateChange(date)}
                    format="MM/dd/yyyy"
                    minDate={new Date()}
                    initialFocusedDate={null}
                    minDateMessage="Date should not be in past"
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)" }}
            direction="row"
            alignContent="center"
            justify="center"
          >
            <Grid
              item
              sm={3}
              md={3}
              style={{ display: window.innerWidth > 768 ? "flex" : "none" }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ThemeProvider theme={theme}>
                  <KeyboardDatePicker
                    id="differentDateByDate"
                    className={`${classes.datepickerroot} ${classes.topBarItem}`}
                    fullWidth
                    inputVariant="standard"
                    orientation="landscape"
                    value={selectedDate}
                    label="Pick different date"
                    onChange={(date) => handleDateChange(date)}
                    format="MM/dd/yyyy"
                    minDate={new Date()}
                    initialFocusedDate={null}
                    minDateMessage="Date should not be in past"
                  />
                </ThemeProvider>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid
              item
              xs={2}
              sm={1}
              md={1}
              style={{ display: "flex" }}
              justify="center"
            >
              {indexNumber === 0 ? (
                <div></div>
              ) : (
                <Tooltip title="Previous">
                  <IconButton
                    aria-label="previous"
                    onClick={() => setIndexNumber(indexNumber - 1)}
                  //style={{fontSize:"0.7rem"}}
                  >
                    <NavigateBeforeIcon
                      className={styles.navigationArrows}
                      fontSize="large"
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
            {loading ? (
              <Grid
                item
                xs={8}
                sm={8}
                md={6}
                style={{ display: "flex" }}
                justify="center"
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={8}
                sm={8}
                md={6}
                style={{
                  display: "flex",
                  textAlign: window.innerWidth < 768 ? "center" : "left",
                }}
                justify="center"
              >
                {providerSchedules?.schedulesByDate.length === 0 ? (
                  <Card
                    className={styles.bydateProviderCard}
                    style={{ boxShadow: "none" }}
                  >
                    <CardMedia
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Avatar
                        className={styles.slotspage_Avatar}
                        src={
                          "/Images/Providers/" +
                          state.appointmentdetails.provider.id +
                          ".jpg"
                        }
                      />
                    </CardMedia>
                    <CardContent>
                      <Typography variant="h6">
                        <b>{state.appointmentdetails.provider.name}</b>
                      </Typography>
                      {/* FB 4769 BEGIN */}
                      <Typography style={{ fontSize: "smaller" }}>
                        {state.appointmentdetails.provider.job_title}
                        <br />
                        {state.appointmentdetails.provider.bio}
                      </Typography>
                      {/* FB 4769 END */}
                    </CardContent>
                  </Card>
                ) : (
                  <Card
                    className={styles.bydateProviderCard}
                    style={{ boxShadow: "none" }}
                  >
                    <CardMedia
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Avatar
                        className={styles.slotspage_Avatar}
                        src={
                          "/Images/Providers/" +
                          providerSchedules?.schedulesByDate[indexNumber]
                            .Employee_N +
                          ".jpg"
                        }
                      />
                    </CardMedia>
                    <CardContent>
                      <Typography variant="h6">
                        <b>
                          {
                            providerSchedules?.schedulesByDate[indexNumber]
                              .Employee_First_Name
                          }{" "}
                          {
                            providerSchedules?.schedulesByDate[indexNumber]
                              .Employee_Last_Name
                          }
                        </b>
                      </Typography>

                      {/* FB 4769 BEGIN */}
                      <Typography style={{ fontSize: "smaller" }}>
                        {
                          providerSchedules?.schedulesByDate[indexNumber]
                            .Employee_Job_Title
                        }
                        <br />
                        {
                          providerSchedules?.schedulesByDate[indexNumber]
                            .Employee_Bio
                        }
                      </Typography>
                      {/* FB 4769 END */}
                      <Typography
                        //variant="subtitle1"
                        style={{
                          color: "red",
                          display:
                            state.appointmentdetails.isInsuranceExist === "No"
                              ? "none"
                              : providerSchedules?.schedulesByDate[indexNumber]
                                .isInsuranceAccepted
                                ? "none"
                                : "inline-flex",
                        }}
                      >
                        This provider does not accept the selected insurance at
                        this location.
                      </Typography>
                      <Typography
                        style={{
                          fontSize: "smaller",
                          color: "red",
                          display:
                            state.appointmentdetails.isInsuranceExist === "No"
                              ? "none"
                              : providerSchedules?.schedulesByDate[indexNumber]
                                .isInsuranceAccepted
                                ? "none"
                                : "inline-flex",
                        }}
                      >
                        (If your insurance plan includes out-of-network
                        coverage, please ignore this warning)
                      </Typography>
                    </CardContent>
                  </Card>
                )}
              </Grid>
            )}
            <Grid
              item
              xs={2}
              sm={1}
              md={1}
              style={{ display: "flex" }}
              justify="center"
            >
              {indexNumber + 1 === providerSchedules?.schedulesByDate.length ? (
                <div></div>
              ) : (
                <Tooltip title="Next">
                  <IconButton
                    aria-label="next"
                    onClick={() => setIndexNumber(indexNumber + 1)}
                  >
                    <NavigateNextIcon
                      className={styles.navigationArrows}
                      fontSize="large"
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            style={{ display: "flex" }}
            direction="row"
            alignContent="center"
            justify="center"
          >
            {loading ? (
              <Grid item xs={12} style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                  style={{ display: "flex", minHeight: "40vh" }}
                >
                  <CircularProgress />
                </Grid>
              </Grid>
            ) : providerSchedules?.schedulesByDate[indexNumber]
              .FacilityByDate[0].Slots.length === 0
              && providerSchedules.schedulesByDate[indexNumber]
                .NextAvailability === null
              ? (
                <div>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    style={{ display: "flex", minHeight: "40vh" }}
                    alignItems="center"
                    justify="center"
                  >
                    <Grid
                      item
                      xs={12}
                      style={{ display: "flex" }}
                      justify="center"
                      alignItems="center"
                    >
                      <Paper
                        style={{
                          backgroundColor: "#EDEEEE",
                          borderRadius: "16px",
                          padding: "10px",
                          fontSize: "smaller",
                        }}
                      >
                        {/* FB 7418 Begin */}
                        {!textValue ? (
                          <Typography>
                            {/* FB 4774 DK - Modified message */}
                            {/* FB 4867 */}
                            There are no online appointments available for this provider. Please call {formatphone(providerSchedules.schedulesByDate[indexNumber].FacilityByDate[0].SchedulinPhone)} to book an appointment.
                          </Typography>) :
                          <Typography
                            variant="subtitle2"
                            style={{ textAlign: "center" }}
                          >
                            {/* FB 4774 - Modified the message */}
                            {/* FB 4867 */}
                            {/* FB 8680 */}
                            {providerSchedules.schedulesByDate[indexNumber].FacilityByDate[0].SchedulinPhone.length > 0 ? textMessage.replace("@practice_phone", providerSchedules.schedulesByDate[indexNumber].FacilityByDate[0].SchedulinPhone)
                              : textMessage.replace("@practice_phone", defaultPhone)}
                          </Typography>
                        }
                        {/* FB 7418 End */}
                      </Paper>
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <Grid
                  item
                  xs={12}
                  style={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                  {providerSchedules?.schedulesByDate[
                    indexNumber
                  ].FacilityByDate.map((ele: FacilityByDate, index: number) => {
                    return (
                      <DateScheduleRow
                        Provider={providerSchedules}
                        FacilityByDate={ele}
                        Limited={limited}
                        indexNumber={indexNumber}
                        Index={index}
                        isLoading={setLoading}    //FB 4409 DK - Added to update the isLoading flag on slots page
                      />
                    );
                  })}
                </Grid>
              )}
          </Grid>

          <Grid
            container
            spacing={2}
            className={styles.flexend_Grid}
            style={{ marginTop: 10, display: "flex" }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className={styles.flexend_Grid}
              style={{ marginTop: 10 }}
            >
              <Button
                onClick={handleGoBack}
                id="goBackDatePage"
                variant="contained"
                className={styles.navigationButton}
              >
                Go Back
              </Button>
            </Grid>
          </Grid>

          {/* FB 4867 DK - Removed unused code */}
        </section>
      )}
    </React.Fragment>
  );
}
